import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver/theme.min.js';
import 'tinymce/skins/ui/oxide/skin.min.css';
import Editor from '@tinymce/tinymce-vue';
import './vi_VN.js'
// Plugins
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/imagetools';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/media';
import 'tinymce/plugins/noneditable';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/print';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/tabfocus';
import 'tinymce/plugins/template';
import 'tinymce/plugins/textpattern';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/bbcode';
import 'tinymce/plugins/code';
import 'tinymce/plugins/colorpicker';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/fullpage';
import 'tinymce/plugins/help';
import 'tinymce/plugins/image';
import 'tinymce/plugins/importcss';
import 'tinymce/plugins/legacyoutput';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/save';
import 'tinymce/plugins/spellchecker';
import 'tinymce/plugins/table';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/toc';
import 'tinymce/plugins/visualchars';

const TOOLBAR_MOBILE = 'bold italic underline strikethrough alignleft aligncenter alignright alignjustify'
const TOOLBAR_DESKTOP = 'bold italic underline strikethrough alignleft aligncenter alignright alignjustify alignnone' +
' styleselect formatselect fontselect fontsizeselect cut copy paste outdent indent blockquote' +
' undo redo removeformat subscript superscript insert'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  components: {
    tinymce: Editor
  },
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: String
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: String
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: this.R.clone(this.modelProps),
      otherOptions: {
        language: 'vi_VN',
        branding: false,
        menubar: 'file edit insert view format table tools help',
        mobile:{
          theme: 'silver'
        },
        height: 480,
        plugins: 
          'advlist autolink lists link image charmap print preview hr anchor pagebreak' +
          ' searchreplace visualblocks visualchars code fullscreen' +
          ' insertdatetime media nonbreaking save table directionality' +
          ' template paste textpattern imagetools toc help hr codesample',
        toolbar: this.$q.screen.xs ? TOOLBAR_MOBILE : TOOLBAR_DESKTOP
      }
    }
  },
  mounted () {
    if(this.config.readonly) {
      this.$refs[`tiny-${this._uid}`].editor.setMode('readonly')
    }
  },
  watch: {
    value () {
      this.$emit('input', this.value)
    }
  },
  computed: {
    validationRules () {
      return this.expressionResolver(this.config.validation)
    }
  },
  methods: {
    onBlur () {}
  }
}
